/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
const CommerceKindList = () =>
  import(
    /* webpackChunkName: "refund-by-transfer-report" */
    '@/views/RefundByTransfer/Report.vue'
  );

const commerceKindRoutes = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/refund-by-transfer',
      component: CommerceKindList,
      meta: {
        navbarType: 'light',
      },
    }
  ],
};
export default commerceKindRoutes;
